module["exports"] = ["sgate", "svei", "s Gate", "s Vei", "gata", "veien"];